"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _excluded = ["unique"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  unique: _propTypes.string
};

var Dashboard = function Dashboard(_ref) {
  var _ref$unique = _ref.unique,
      unique = _ref$unique === void 0 ? "" : _ref$unique,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", {
    fill: "inherit"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    fillRule: "evenodd",
    id: "glyphs/nav/dashboard-dashboard" + unique,
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/_react["default"].createElement("use", {
    fill: "inherit",
    fillRule: "nonzero",
    id: "grey600-dashboard" + unique,
    xlinkHref: "#path-1-dashboard" + unique
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    id: "colors/core/gunmetal-dashboard" + unique
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14,3 L20,3 C20.5522847,3 21,3.44771525 21,4 L21,8 C21,8.55228475 20.5522847,9 20,9 L14,9 C13.4477153,9 13,8.55228475 13,8 L13,4 C13,3.44771525 13.4477153,3 14,3 Z M14,11 L20,11 C20.5522847,11 21,11.4477153 21,12 L21,20 C21,20.5522847 20.5522847,21 20,21 L14,21 C13.4477153,21 13,20.5522847 13,20 L13,12 C13,11.4477153 13.4477153,11 14,11 Z M4,15 L10,15 C10.5522847,15 11,15.4477153 11,16 L11,20 C11,20.5522847 10.5522847,21 10,21 L4,21 C3.44771525,21 3,20.5522847 3,20 L3,16 C3,15.4477153 3.44771525,15 4,15 Z M4,3 L10,3 C10.5522847,3 11,3.44771525 11,4 L11,12 C11,12.5522847 10.5522847,13 10,13 L4,13 C3.44771525,13 3,12.5522847 3,12 L3,4 C3,3.44771525 3.44771525,3 4,3 Z",
    fill: "inherit",
    id: "path-1-dashboard" + unique
  }))));
};

Dashboard.propTypes = propTypes;
var _default = Dashboard;
exports["default"] = _default;